import { render, staticRenderFns } from "./BlockRenderPlayer.vue?vue&type=template&id=8d48e0da"
import script from "./BlockRenderPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockRenderPlayer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports